import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsKeybaseComponent } from './simple-icons-keybase.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsKeybaseComponent ],
    exports:      [ SimpleIconsKeybaseComponent ],
    bootstrap:    []
})
export class SimpleIconsKeybaseModule {}
